import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "g-container mx-[30px]" }
const _hoisted_3 = { class: "mt-[30px] font-bold text-lg sm:text-2xl text-gary-line-color" }
const _hoisted_4 = { class: "my-[10px] mb-[20px] sm:my-[20px] text-sm text-gary-text-color tracking-[.06em] flex gap-2 leading-[24px]" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 訂單編號")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("# ")
const _hoisted_7 = { class: "g-container" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row gap-5 sm:gap-2.5 mt-2.5" }
const _hoisted_9 = { class: "flex flex-col grow gap-2.5" }
const _hoisted_10 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_13 = { class: "w-[80px]" }
const _hoisted_14 = { class: "grow flex flex-col" }
const _hoisted_15 = { class: "flex ml-[30px]" }
const _hoisted_16 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_17 = { class: "text-base font-medium text-gary-text-color" }
const _hoisted_18 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_19 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_20 = { class: "hidden" }
const _hoisted_21 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_23 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_25 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "grow h-[60px] flex items-center" }
const _hoisted_31 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_32 = { class: "flex-1 mr-[30px]" }
const _hoisted_33 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_34 = {
  key: 0,
  class: "flex"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[30px]" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[130px]" }, null, -1)
const _hoisted_37 = { class: "grow flex flex-col" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "w-[46%]" }
const _hoisted_40 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_41 = { class: "flex mb-[20px]" }
const _hoisted_42 = { class: "w-[80px] mr-[20px]" }
const _hoisted_43 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color mb-1" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "包裝盒 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "吊卡 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "貼紙 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "防塵袋 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "紙袋 x1")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_46 = { class: "grow flex" }
const _hoisted_47 = { class: "grow text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right mr-[30px]" }
const _hoisted_48 = {
  key: 1,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_49 = { class: "bg-img-background flex pt-[20px]" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_51 = { class: "w-[80px]" }
const _hoisted_52 = { class: "grow flex flex-col" }
const _hoisted_53 = { class: "flex ml-[30px]" }
const _hoisted_54 = { class: "w-[46%]" }
const _hoisted_55 = { class: "flex" }
const _hoisted_56 = { class: "w-[20px] mr-1.5" }
const _hoisted_57 = { class: "flex items-center mb-1.5 font-medium text-sm text-gary-text-color" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
    /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
    /*#__PURE__*/_createElementVNode("li", null, "霧面")
  ])
], -1)
const _hoisted_59 = { class: "grow h-[60px] flex items-center" }
const _hoisted_60 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_61 = { class: "grow mr-[30px]" }
const _hoisted_62 = { class: "text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_63 = {
  key: 2,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_65 = { class: "w-[80px]" }
const _hoisted_66 = { class: "grow flex flex-col" }
const _hoisted_67 = { class: "flex ml-[30px]" }
const _hoisted_68 = { class: "w-[46%]" }
const _hoisted_69 = { class: "flex" }
const _hoisted_70 = { class: "w-[20px] mr-1.5" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
    /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
    /*#__PURE__*/_createElementVNode("li", null, "霧面")
  ])
], -1)
const _hoisted_72 = { class: "grow h-[60px] flex items-center" }
const _hoisted_73 = { class: "grow mr-[30px]" }
const _hoisted_74 = { class: "flex justify-end my-3" }
const _hoisted_75 = { class: "flex gap-[14px] tracking-[.06em] mr-7 text-sm items-center text-gary-text-color" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_77 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_78 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_80 = { class: "w-[60px]" }
const _hoisted_81 = { class: "grow flex flex-col" }
const _hoisted_82 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_83 = { class: "flex flex-col gap-1" }
const _hoisted_84 = { class: "flex flex-row justify-between" }
const _hoisted_85 = { class: "" }
const _hoisted_86 = { class: "text-[13px] font-medium text-gary-text-color" }
const _hoisted_87 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_88 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_89 = { class: "hidden" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" 顯示產品詳細資訊")
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" 隱藏產品詳細資訊")
const _hoisted_92 = {
  key: 2,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_96 = [
  _hoisted_93,
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_98 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_99 = { class: "mr-[16px]" }
const _hoisted_100 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_101 = {
  key: 0,
  class: "flex flex-row mt-5 mb-3"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_103 = { class: "w-[60px]" }
const _hoisted_104 = { class: "grow flex flex-col" }
const _hoisted_105 = { class: "flex flex-col ml-[6px]" }
const _hoisted_106 = { class: "flex flex-col gap-1 sm:w-[46%]" }
const _hoisted_107 = { class: "flex flex-row justify-between" }
const _hoisted_108 = { class: "" }
const _hoisted_109 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-xs" }
const _hoisted_110 = { class: "flex" }
const _hoisted_111 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_113 = { class: "grow h-[37px] flex flex-row items-center justify-end" }
const _hoisted_114 = { class: "mr-[16px]" }
const _hoisted_115 = { class: "text-[13px] sm:leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_116 = {
  key: 1,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_117 = { class: "bg-img-background flex pt-[20px] flex-row pt-5 pb-5" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_119 = { class: "w-[60px]" }
const _hoisted_120 = { class: "grow flex flex-col" }
const _hoisted_121 = { class: "flex flex-col ml-[6px]" }
const _hoisted_122 = { class: "flex flex-col gap-1" }
const _hoisted_123 = { class: "flex flex-row justify-between" }
const _hoisted_124 = { class: "" }
const _hoisted_125 = { class: "flex" }
const _hoisted_126 = { class: "w-[20px] mr-1.5" }
const _hoisted_127 = { class: "items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_129 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_130 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_131 = { class: "mr-[16px]" }
const _hoisted_132 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_133 = {
  key: 2,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_135 = { class: "w-[60px]" }
const _hoisted_136 = { class: "grow flex flex-col" }
const _hoisted_137 = { class: "flex flex-col ml-[6px]" }
const _hoisted_138 = { class: "flex flex-col gap-1" }
const _hoisted_139 = { class: "flex flex-row justify-between" }
const _hoisted_140 = { class: "" }
const _hoisted_141 = { class: "flex" }
const _hoisted_142 = { class: "w-[20px] mr-1.5" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_144 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_145 = { class: "mr-[16px]" }
const _hoisted_146 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_147 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center text-gary-text-color" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_149 = {
  key: 0,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_150 = { class: "w-[20px] mr-2.5" }
const _hoisted_151 = /*#__PURE__*/_createTextVNode(" 滿額加購")
const _hoisted_152 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_155 = { class: "w-[80px]" }
const _hoisted_156 = { class: "grow flex flex-col" }
const _hoisted_157 = { class: "flex ml-[30px]" }
const _hoisted_158 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_159 = { class: "flex text-sm font-medium text-gary-text-color" }
const _hoisted_160 = { class: "w-[20px] mr-1.5" }
const _hoisted_161 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_162 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_163 = { class: "hidden" }
const _hoisted_164 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_165 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_166 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_167 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_168 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_169 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_170 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_172 = [
  _hoisted_169,
  _hoisted_170,
  _hoisted_171
]
const _hoisted_173 = { class: "grow h-[60px] flex items-center" }
const _hoisted_174 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_175 = { class: "flex-1 mr-[30px]" }
const _hoisted_176 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_177 = { class: "flex justify-end my-3" }
const _hoisted_178 = { class: "flex gap-[14px] tracking-[.06em] mr-7 text-sm items-center text-gary-text-color" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_180 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_181 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_183 = { class: "w-[60px]" }
const _hoisted_184 = { class: "grow flex flex-col" }
const _hoisted_185 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_186 = { class: "flex flex-col gap-1" }
const _hoisted_187 = { class: "flex flex-row justify-between" }
const _hoisted_188 = { class: "" }
const _hoisted_189 = { class: "flex text-[13px] font-medium text-gary-text-color" }
const _hoisted_190 = { class: "w-[20px] mr-1.5" }
const _hoisted_191 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_192 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_193 = { class: "hidden" }
const _hoisted_194 = /*#__PURE__*/_createTextVNode(" 顯示產品詳細資訊")
const _hoisted_195 = /*#__PURE__*/_createTextVNode(" 隱藏產品詳細資訊")
const _hoisted_196 = {
  key: 2,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_197 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_199 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_200 = [
  _hoisted_197,
  _hoisted_198,
  _hoisted_199
]
const _hoisted_201 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_202 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_203 = { class: "mr-[16px]" }
const _hoisted_204 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_205 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_206 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center text-gary-text-color" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_208 = {
  key: 1,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_209 = { class: "w-[20px] mr-2.5" }
const _hoisted_210 = /*#__PURE__*/_createTextVNode(" 贈品")
const _hoisted_211 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_212 = { class: "flex mt-5 min-h-[100px]" }
const _hoisted_213 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_214 = { class: "w-[80px]" }
const _hoisted_215 = { class: "grow flex flex-col" }
const _hoisted_216 = { class: "flex ml-[30px]" }
const _hoisted_217 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_218 = { class: "flex text-sm font-medium text-gary-text-color" }
const _hoisted_219 = { class: "mr-1.5 w-[20px]" }
const _hoisted_220 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_221 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_222 = { class: "hidden" }
const _hoisted_223 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_224 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_225 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_226 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_227 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_228 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_229 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_230 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_231 = [
  _hoisted_228,
  _hoisted_229,
  _hoisted_230
]
const _hoisted_232 = { class: "grow h-[60px] flex items-center" }
const _hoisted_233 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_234 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_235 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_236 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_237 = { class: "w-[60px]" }
const _hoisted_238 = { class: "grow flex flex-col" }
const _hoisted_239 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_240 = { class: "flex flex-col gap-1" }
const _hoisted_241 = { class: "flex flex-row justify-between" }
const _hoisted_242 = { class: "" }
const _hoisted_243 = { class: "flex text-[13px] font-medium text-gary-text-color" }
const _hoisted_244 = { class: "mr-1.5 w-[20px]" }
const _hoisted_245 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_246 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_247 = { class: "hidden" }
const _hoisted_248 = /*#__PURE__*/_createTextVNode(" 顯示產品詳細資訊")
const _hoisted_249 = /*#__PURE__*/_createTextVNode(" 隱藏產品詳細資訊")
const _hoisted_250 = {
  key: 2,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_251 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_252 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_253 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_254 = [
  _hoisted_251,
  _hoisted_252,
  _hoisted_253
]
const _hoisted_255 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_256 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_257 = { class: "basis-[42%] flex flex-col gap-5 sm:gap-2.5 px-2.5 sm:px-0" }
const _hoisted_258 = { class: "bg-white rounded-md pt-[36px] px-[14px] sm:px-[30px] pb-[40px] divide-y-[1px]" }
const _hoisted_259 = { class: "flex flex-col pb-[40px] px-2.5 gap-[30px]" }
const _hoisted_260 = { class: "flex font-bold text-sm text-gary-text-color mb-2.5" }
const _hoisted_261 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "訂單狀態", -1)
const _hoisted_262 = { class: "grow text-right text-primary-color" }
const _hoisted_263 = { class: "flex text-sm tracking-[.06em] text-gary-text-color mb-[11px]" }
const _hoisted_264 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2.5" }, "訂單編號", -1)
const _hoisted_265 = { class: "font-medium underline underline-offset-2" }
const _hoisted_266 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 購買人 ", -1)
const _hoisted_267 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_268 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[5px]" }
const _hoisted_269 = { class: "text-[13px] tracking-[.12em] text-gary-text-color" }
const _hoisted_270 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 收件資料 ", -1)
const _hoisted_271 = { class: "flex text-sm tracking-[.06em] text-gary-text-color mb-[5px]" }
const _hoisted_272 = { class: "mr-[15px]" }
const _hoisted_273 = { class: "" }
const _hoisted_274 = { class: "flex text-sm tracking-[.06em] text-gary-text-color mb-[5px]" }
const _hoisted_275 = { class: "mr-[15px]" }
const _hoisted_276 = { class: "text-[13px] tracking-[.12em] text-gary-text-color" }
const _hoisted_277 = /*#__PURE__*/_createTextVNode(" 據點地址｜")
const _hoisted_278 = { class: "cursor-pointer text-primary-color underline" }
const _hoisted_279 = {
  key: 1,
  class: "text-[13px] w-[100%] text-light-gary-text-color md:whitespace-nowrap mb-[5px]"
}
const _hoisted_280 = {
  key: 2,
  class: "sm:w-[45%] text-light-gary-text-color text-[13px] tracking-[.12em]"
}
const _hoisted_281 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 發票類型 ", -1)
const _hoisted_282 = { key: 0 }
const _hoisted_283 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_284 = { class: "text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_285 = { key: 1 }
const _hoisted_286 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }, " 手機條碼載具 ", -1)
const _hoisted_287 = { class: "text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_288 = { key: 2 }
const _hoisted_289 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_290 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_291 = { class: "text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_292 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 付款方式 ", -1)
const _hoisted_293 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-2.5" }
const _hoisted_294 = {
  key: 0,
  class: "flex flex-col gap-[10px] text-sm text-breadcrumb-color font-medium mb-[30px]"
}
const _hoisted_295 = /*#__PURE__*/_createElementVNode("div", { class: "text-light-gary-text-color text-[13px] tracking-[.12em] mt-[20px]" }, " 以上訂單資料已發送到您的電子郵件。 如果該訂單資料沒有出現在收件夾，請檢查垃圾郵件箱。 ", -1)
const _hoisted_296 = { key: 0 }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 訂單備註 ", -1)
const _hoisted_298 = { class: "text-light-gary-text-color text-[13px] tracking-[.12em] mt-[20px]" }
const _hoisted_299 = { class: "flex flex-col divide-y-2 px-2.5 pt-[40px]" }
const _hoisted_300 = { class: "flex flex-col ml-1 gap-[18px] text-base text-gary-text-color mb-[20px]" }
const _hoisted_301 = { class: "flex" }
const _hoisted_302 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "商品金額", -1)
const _hoisted_303 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_304 = { class: "flex" }
const _hoisted_305 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "運費小計", -1)
const _hoisted_306 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_307 = { class: "flex" }
const _hoisted_308 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "優惠", -1)
const _hoisted_309 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_310 = { class: "pt-[20px] flex flex-col" }
const _hoisted_311 = { class: "flex text-black-900-color leading-[23px] items-center mb-[40px]" }
const _hoisted_312 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "應付總額", -1)
const _hoisted_313 = { class: "grow text-lg text-right font-bold" }
const _hoisted_314 = { class: "flex flex-col gap-[10px]" }
const _hoisted_315 = { class: "hidden g-container mt-[20px] mx-2.5 sm:mx-0 bg-white rounded-md p-[16px] sm:p-[40px]" }
const _hoisted_316 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium mb-1.5 text-sm text-gary-text-color" }, " 懶人快速問 ", -1)
const _hoisted_317 = { class: "flex flex-col sm:flex-row gap-5" }
const _hoisted_318 = /*#__PURE__*/_createElementVNode("div", { class: "flex sm:w-[600px] h-[300px] sm:h-[500px] bg-red border-[1px] rounded-md items-center text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full text-[13px] text-black-400-color tracking-[.12em]" }, " - 尚未有訊息，請至右側發問 - ")
], -1)
const _hoisted_319 = { class: "sm:w-[500px] h-fit flex flex-col" }
const _hoisted_320 = { class: "flex justify-between mt-7 items-center" }
const _hoisted_321 = { class: "flex text-sm sm:text-base gap-2 text-gary-text-color tracking-[.06em]" }
const _hoisted_322 = /*#__PURE__*/_createTextVNode(" 加入圖片 ")
const _hoisted_323 = /*#__PURE__*/_createElementVNode("div", { class: "w-[90px] sm:w-[121px] h-[36px] text-sm text-white rounded-[10px] bg-gary-text-color leading-9 text-center" }, " 確認 ", -1)
const _hoisted_324 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[30px] p-1 text-[13px] text-light-gary-text-color tracking-[.12em]" }, " 訂單問答回覆時間：週一至週五09:00-18:00(中午休息時間12:00-13:00) 於當日六點後或週末提問，將統一於上班時間六點前依序回覆完畢，還請稍待，謝謝 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_UnderLine = _resolveComponent("UnderLine")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_ctx.orderDetail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, " 謝謝，" + _toDisplayString(_ctx.store.state.userInfo.Name), 1),
          _createElementVNode("div", {
            class: "mt-[10px] text-sm sm:text-base font-bold text-gary-text-color cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToPreviousPage && _ctx.backToPreviousPage(...args)))
          }, " <   返回訂購紀錄 "),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, [
              _hoisted_6,
              _createElementVNode("span", { ref: "copyOrderId" }, _toDisplayString(_ctx.orderDetail.OrderId), 513)
            ]),
            _createVNode(_component_Icon, {
              class: "cursor-pointer",
              onClick: _ctx.handleCopy,
              onKeyup: _ctx.handleCopy,
              iconName: "copy2",
              width: '24px'
            }, null, 8, ["onClick", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItemList, (orderItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: orderItem.OrderItemId,
                  class: "flex flex-col gap-2.5"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "flex mt-5 cursor-pointer",
                      onClick: ($event: any) => (_ctx.goProductDetail(orderItem))
                    }, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '80px',
                          image: orderItem.CmdyImage.PcWeb
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.unescapeHTML(orderItem.CmdyName)), 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.unescapeHTML(orderItem.CmdySubName)), 1),
                            (orderItem.EditorPortfolioId !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(orderItem.PortfolioName)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", {
                                class: "text-xs text-primary-color cursor-pointer",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.detail = !_ctx.detail))
                              }, [
                                (!_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                      _hoisted_22,
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_down",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                      _hoisted_24,
                                      (_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_up",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.detail)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_25, _hoisted_29))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(orderItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, " NT. " + _toDisplayString(orderItem.CmdyAmt), 1)
                            ])
                          ])
                        ])
                      ])
                    ], 8, _hoisted_11),
                    (orderItem.PackageCmdyList?.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _hoisted_35,
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_UnderLine, { class: "w-auto ml-[111px] sm:ml-0 mb-5" }),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_Icon, {
                                    class: "mr-1.5",
                                    iconName: "package",
                                    width: '20px'
                                  }),
                                  _createTextVNode("禮品包裝 - " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: orderItem.PackageCmdyList[0].CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(orderItem.PackageCmdyList[0].CmdyIncludeDesc), 1),
                                  _hoisted_44,
                                  _hoisted_45
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, " NT. " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyAmt), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.AddOnCmdyList?.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.AddOnCmdyList, (addOnCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: addOnCmdyItem.CmdyId,
                              class: "add-on-item"
                            }, [
                              _createElementVNode("div", _hoisted_49, [
                                _hoisted_50,
                                _createElementVNode("div", _hoisted_51, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '80px',
                                    image: addOnCmdyItem.CmdyImage.PcWeb,
                                    customClass: 'square-photo-content-no-cursor'
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("div", _hoisted_54, [
                                      _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("div", _hoisted_56, [
                                          _createVNode(_component_Icon, {
                                            iconName: 'add_on'
                                ,
                                            width: '20px'
                                          })
                                        ]),
                                        _createElementVNode("span", _hoisted_57, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                      ]),
                                      _hoisted_58
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      _createElementVNode("div", _hoisted_60, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                      _createElementVNode("div", _hoisted_61, [
                                        _createElementVNode("div", _hoisted_62, " NT." + _toDisplayString(addOnCmdyItem.CmdyAmt), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.GiveawayCmdyList.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: giveawayCmdyItem.CmdyId,
                              class: "add-on-item"
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px]"])
                              }, [
                                _hoisted_64,
                                _createElementVNode("div", _hoisted_65, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '80px',
                                    image: giveawayCmdyItem.CmdyImage.PcWeb,
                                    customClass: 'square-photo-content-no-cursor'
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("div", _hoisted_67, [
                                    _createElementVNode("div", _hoisted_68, [
                                      _createElementVNode("div", _hoisted_69, [
                                        _createElementVNode("div", _hoisted_70, [
                                          _createVNode(_component_Icon, {
                                            iconName: 
                                  giveawayCmdyItem.CmdyQty == 0
                                    ? 'giveaway_gray'
                                    : 'giveaway_black'
                                ,
                                            width: '20px'
                                          }, null, 8, ["iconName"])
                                        ]),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                        }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                      ]),
                                      _hoisted_71
                                    ]),
                                    _createElementVNode("div", _hoisted_72, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base text-right", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                      }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                      _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                        }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFee), 3)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 2)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _hoisted_76,
                        _createTextVNode(" NT. " + _toDisplayString(orderItem.TotalAmount), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createElementVNode("div", _hoisted_80, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '60px',
                          image: orderItem.CmdyImage.MobileWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.unescapeHTML(orderItem.CmdyName)), 1),
                                _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.unescapeHTML(orderItem.CmdySubName)), 1),
                                (orderItem.EditorPortfolioId !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(orderItem.PortfolioName)), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_89, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_90,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_91,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_92, _hoisted_96))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("div", _hoisted_98, _toDisplayString(orderItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_99, [
                              _createElementVNode("div", _hoisted_100, " NT. " + _toDisplayString(orderItem.CmdyAmt), 1)
                            ])
                          ])
                        ]),
                        (orderItem.PackageCmdyList?.length !== 0)
                          ? (_openBlock(), _createBlock(_component_UnderLine, {
                              key: 0,
                              class: "w-auto ml-1"
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (orderItem.PackageCmdyList?.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                          _hoisted_102,
                          _createElementVNode("div", _hoisted_103, [
                            _createVNode(_component_SquareItemFullImage, {
                              width: '60px',
                              image: orderItem.PackageCmdyList[0].CmdyImage.MobileWeb,
                              customClass: ''
                            }, null, 8, ["image"])
                          ]),
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("div", _hoisted_105, [
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, [
                                  _createElementVNode("div", _hoisted_108, [
                                    _createElementVNode("div", _hoisted_109, [
                                      _createVNode(_component_Icon, {
                                        class: "mr-1.5",
                                        iconName: "package",
                                        width: '20px'
                                      }),
                                      _createTextVNode("禮品包裝 - " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyName), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_110, [
                                      _createElementVNode("div", _hoisted_111, _toDisplayString(orderItem.PackageCmdyList[0]
                                  .CmdyIncludeDesc), 1),
                                      _hoisted_112
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_113, [
                                _createElementVNode("div", _hoisted_114, [
                                  _createElementVNode("div", _hoisted_115, " NT. " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyAmt), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.AddOnCmdyList?.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.AddOnCmdyList, (addOnCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex-row",
                              key: addOnCmdyItem.CmdyId
                            }, [
                              _createElementVNode("div", _hoisted_117, [
                                _hoisted_118,
                                _createElementVNode("div", _hoisted_119, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '60px',
                                    image: addOnCmdyItem.CmdyImage.MobileWeb,
                                    customClass: 'square-photo-content-no-cursor'
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_120, [
                                  _createElementVNode("div", _hoisted_121, [
                                    _createElementVNode("div", _hoisted_122, [
                                      _createElementVNode("div", _hoisted_123, [
                                        _createElementVNode("div", _hoisted_124, [
                                          _createElementVNode("div", _hoisted_125, [
                                            _createElementVNode("div", _hoisted_126, [
                                              _createVNode(_component_Icon, {
                                                iconName: 'add_on'
                                    ,
                                                width: '20px'
                                              })
                                            ]),
                                            _createElementVNode("span", _hoisted_127, "加購商提 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                          ]),
                                          _hoisted_128
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_129, [
                                      _createElementVNode("div", _hoisted_130, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                      _createElementVNode("div", _hoisted_131, [
                                        _createElementVNode("div", _hoisted_132, " NT." + _toDisplayString(addOnCmdyItem.CmdyAmt), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.GiveawayCmdyList.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex-row",
                              key: giveawayCmdyItem.CmdyId
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([{
                      'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                      'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                    }, "flex pt-[20px] flex-row pt-5 pb-5"])
                              }, [
                                _hoisted_134,
                                _createElementVNode("div", _hoisted_135, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '60px',
                                    image: giveawayCmdyItem.CmdyImage.MobileWeb,
                                    customClass: 'square-photo-content-no-cursor'
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_136, [
                                  _createElementVNode("div", _hoisted_137, [
                                    _createElementVNode("div", _hoisted_138, [
                                      _createElementVNode("div", _hoisted_139, [
                                        _createElementVNode("div", _hoisted_140, [
                                          _createElementVNode("div", _hoisted_141, [
                                            _createElementVNode("div", _hoisted_142, [
                                              _createVNode(_component_Icon, {
                                                iconName: 
                                      giveawayCmdyItem.CmdyQty == 0
                                        ? 'giveaway_gray'
                                        : 'giveaway_black'
                                    ,
                                                width: '20px'
                                              }, null, 8, ["iconName"])
                                            ]),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color", {
                                    'text-black-400-color':
                                      giveawayCmdyItem.CmdyQty === 0
                                  }])
                                            }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                          ]),
                                          _hoisted_143
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_144, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                      }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                      _createElementVNode("div", _hoisted_145, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["text-[13px] items-center text-gary-text-color tracking-[.06em] text-right", {
                                'text-black-400-color':
                                  giveawayCmdyItem.CmdyQty === 0
                              }])
                                        }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFee), 3)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 2)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("div", _hoisted_147, [
                        _hoisted_148,
                        _createTextVNode(" NT. " + _toDisplayString(orderItem.TotalAmount), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.addOnItemList.length !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_149, [
                    _createElementVNode("div", _hoisted_150, [
                      _createVNode(_component_Icon, {
                        iconName: 'add_on',
                        width: '20px'
                      })
                    ]),
                    _hoisted_151
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addOnItemList, (addOnItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: addOnItem.OrderItemId,
                  class: "flex flex-col gap-2.5"
                }, [
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("div", {
                      class: "flex mt-5 cursor-pointer",
                      onClick: ($event: any) => (_ctx.goProductDetail(addOnItem))
                    }, [
                      _hoisted_154,
                      _createElementVNode("div", _hoisted_155, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '80px',
                          image: addOnItem.CmdyImage.PcWeb
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_156, [
                        _createElementVNode("div", _hoisted_157, [
                          _createElementVNode("div", _hoisted_158, [
                            _createElementVNode("div", _hoisted_159, [
                              _createElementVNode("div", _hoisted_160, [
                                _createVNode(_component_Icon, {
                                  iconName: 'add_on'
                              ,
                                  width: '20px'
                                })
                              ]),
                              _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnItem.CmdyName)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_161, _toDisplayString(_ctx.unescapeHTML(addOnItem.CmdySubName)), 1),
                            (addOnItem.EditorPortfolioId !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_162, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(addOnItem.PortfolioName)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_163, [
                              _createElementVNode("div", {
                                class: "text-xs text-primary-color cursor-pointer",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.detail = !_ctx.detail))
                              }, [
                                (!_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_164, [
                                      _hoisted_165,
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_down",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_166, [
                                      _hoisted_167,
                                      (_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_up",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.detail)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_168, _hoisted_172))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_173, [
                            _createElementVNode("div", _hoisted_174, _toDisplayString(addOnItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_175, [
                              _createElementVNode("div", _hoisted_176, " NT. " + _toDisplayString(addOnItem.CmdyAmt), 1)
                            ])
                          ])
                        ])
                      ])
                    ], 8, _hoisted_153),
                    _createVNode(_component_UnderLine, { class: "w-auto m-0" }),
                    _createElementVNode("div", _hoisted_177, [
                      _createElementVNode("div", _hoisted_178, [
                        _hoisted_179,
                        _createTextVNode(" NT. " + _toDisplayString(addOnItem.TotalAmount), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_180, [
                    _createElementVNode("div", _hoisted_181, [
                      _hoisted_182,
                      _createElementVNode("div", _hoisted_183, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '60px',
                          image: addOnItem.CmdyImage.MobileWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_184, [
                        _createElementVNode("div", _hoisted_185, [
                          _createElementVNode("div", _hoisted_186, [
                            _createElementVNode("div", _hoisted_187, [
                              _createElementVNode("div", _hoisted_188, [
                                _createElementVNode("div", _hoisted_189, [
                                  _createElementVNode("div", _hoisted_190, [
                                    _createVNode(_component_Icon, {
                                      iconName: 'add_on'
                              ,
                                      width: '20px'
                                    })
                                  ]),
                                  _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnItem.CmdyName)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_191, _toDisplayString(_ctx.unescapeHTML(addOnItem.CmdySubName)), 1),
                                (addOnItem.EditorPortfolioId !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_192, " 作品名稱：" + _toDisplayString(_ctx.unescapeHTML(addOnItem.PortfolioName)), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_193, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_194,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_195,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_196, _hoisted_200))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_201, [
                            _createElementVNode("div", _hoisted_202, _toDisplayString(addOnItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_203, [
                              _createElementVNode("div", _hoisted_204, " NT. " + _toDisplayString(addOnItem.CmdyAmt), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_205, [
                      _createElementVNode("div", _hoisted_206, [
                        _hoisted_207,
                        _createTextVNode(" NT. " + _toDisplayString(addOnItem.TotalAmount), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.giveawayItemList.length !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_208, [
                    _createElementVNode("div", _hoisted_209, [
                      _createVNode(_component_Icon, {
                        iconName: 'giveaway_black',
                        width: '20px'
                      })
                    ]),
                    _hoisted_210
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giveawayItemList, (giveawayItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: giveawayItem.OrderItemId,
                  class: "flex flex-col gap-2.5"
                }, [
                  _createElementVNode("div", _hoisted_211, [
                    _createElementVNode("div", _hoisted_212, [
                      _hoisted_213,
                      _createElementVNode("div", _hoisted_214, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '80px',
                          image: giveawayItem.CmdyImage.PcWeb,
                          customClass: 'square-photo-content-no-cursor'
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_215, [
                        _createElementVNode("div", _hoisted_216, [
                          _createElementVNode("div", _hoisted_217, [
                            _createElementVNode("div", _hoisted_218, [
                              _createElementVNode("div", _hoisted_219, [
                                _createVNode(_component_Icon, {
                                  iconName: 'giveaway_black',
                                  width: '20px'
                                })
                              ]),
                              _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayItem.CmdyName)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_220, _toDisplayString(_ctx.unescapeHTML(giveawayItem.CmdySubName)), 1),
                            (giveawayItem.EditorPortfolioId !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_221, " 作品名稱：" + _toDisplayString(giveawayItem.EditorPortfolioName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_222, [
                              _createElementVNode("div", {
                                class: "text-xs text-primary-color cursor-pointer",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.detail = !_ctx.detail))
                              }, [
                                (!_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_223, [
                                      _hoisted_224,
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_down",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_225, [
                                      _hoisted_226,
                                      (_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_up",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.detail)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_227, _hoisted_231))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_232, [
                            _createElementVNode("div", _hoisted_233, _toDisplayString(giveawayItem.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_234, [
                    _createElementVNode("div", _hoisted_235, [
                      _hoisted_236,
                      _createElementVNode("div", _hoisted_237, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '60px',
                          image: giveawayItem.CmdyImage.MobileWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_238, [
                        _createElementVNode("div", _hoisted_239, [
                          _createElementVNode("div", _hoisted_240, [
                            _createElementVNode("div", _hoisted_241, [
                              _createElementVNode("div", _hoisted_242, [
                                _createElementVNode("div", _hoisted_243, [
                                  _createElementVNode("div", _hoisted_244, [
                                    _createVNode(_component_Icon, {
                                      iconName: 'giveaway_black',
                                      width: '20px'
                                    })
                                  ]),
                                  _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayItem.CmdyName)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_245, _toDisplayString(giveawayItem.CmdySubName), 1),
                                (giveawayItem.EditorPortfolioId !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_246, " 作品名稱：" + _toDisplayString(giveawayItem.EditorPortfolioName), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_247, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_248,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_249,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_250, _hoisted_254))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_255, [
                            _createElementVNode("div", _hoisted_256, _toDisplayString(giveawayItem.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_257, [
              _createElementVNode("div", _hoisted_258, [
                _createElementVNode("div", _hoisted_259, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_260, [
                      _hoisted_261,
                      _createElementVNode("div", _hoisted_262, _toDisplayString(_ctx.orderDetail.StatusDesc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_263, [
                      _hoisted_264,
                      _createElementVNode("div", _hoisted_265, " # " + _toDisplayString(_ctx.orderDetail.OrderId), 1),
                      _createVNode(_component_Icon, {
                        class: "cursor-pointer",
                        onClick: _ctx.handleCopy,
                        onKeyup: _ctx.handleCopy,
                        iconName: "copy2",
                        width: '24px'
                      }, null, 8, ["onClick", "onKeyup"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_266,
                    _createElementVNode("div", _hoisted_267, _toDisplayString(_ctx.orderDetail.BuyerName), 1),
                    _createElementVNode("div", _hoisted_268, _toDisplayString(_ctx.orderDetail.BuyerEmail), 1),
                    _createElementVNode("div", _hoisted_269, _toDisplayString(_ctx.orderDetail.BuyerMobile), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_270,
                    _createElementVNode("div", _hoisted_271, [
                      _createElementVNode("div", _hoisted_272, _toDisplayString(_ctx.orderDetail.DeliveryTypeDesc + ` ${_ctx.orderDetail.DeliveryDestName === null || _ctx.orderDetail.DeliveryDestName === '' ?  '' : '- ' + _ctx.orderDetail.DeliveryDestName }`), 1),
                      _createElementVNode("div", _hoisted_273, "NT. " + _toDisplayString(_ctx.orderDetail.FreightAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_274, [
                      _createElementVNode("div", _hoisted_275, _toDisplayString(_ctx.orderDetail.ReceiverName), 1),
                      _createElementVNode("div", _hoisted_276, _toDisplayString(_ctx.orderDetail.ReceiverMobile), 1)
                    ]),
                    (_ctx.orderDetail.DeliveryType === 'GainHowShopSeller')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "text-[13px] w-[80%] text-light-gary-text-color md:whitespace-nowrap mb-[5px]",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args)))
                        }, [
                          _hoisted_277,
                          _createElementVNode("span", _hoisted_278, [
                            _createTextVNode(_toDisplayString(_ctx.orderDetail.DeliveryDestShopAddr), 1),
                            _createVNode(_component_Icon, {
                              class: "inline-block mb-[2px]",
                              iconName: "maps",
                              width: '20px'
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.DeliveryType === 'GainHowShopSeller')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_279, " 營業時間｜" + _toDisplayString(_ctx.orderDetail.DeliveryDestShopBusinessHours), 1))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.DeliveryTypeDesc === '宅配')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_280, _toDisplayString(_ctx.orderDetail.DeliveryCity +
                    _ctx.orderDetail.DeliveryDist +
                    _ctx.orderDetail.DeliveryAddr), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_281,
                    (_ctx.orderDetail.InvoiceCarrierType === 'Member')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_282, [
                          _createElementVNode("div", _hoisted_283, _toDisplayString(_ctx.orderDetail.InvoiceTypeDesc), 1),
                          _createElementVNode("div", _hoisted_284, _toDisplayString(_ctx.orderDetail.InvoiceEmail), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.InvoiceCarrierType === 'Barcode')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                          _hoisted_286,
                          _createElementVNode("div", _hoisted_287, _toDisplayString(_ctx.orderDetail.InvoiceCarrier), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.InvoiceCarrierType === 'None')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_288, [
                          _createElementVNode("div", _hoisted_289, _toDisplayString(_ctx.orderDetail.InvoiceTypeDesc), 1),
                          _createElementVNode("div", _hoisted_290, " 統一編號 " + _toDisplayString(_ctx.orderDetail.InvoiceBizNo), 1),
                          _createElementVNode("div", _hoisted_291, _toDisplayString(_ctx.orderDetail.InvoiceEmail), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_292,
                    _createElementVNode("div", _hoisted_293, _toDisplayString(_ctx.orderDetail.PaymentTypeDesc), 1),
                    (_ctx.orderDetail.PaymentTypeDesc === 'ATM')
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_294, [
                          _createElementVNode("li", null, "訂單編號：" + _toDisplayString(_ctx.orderDetail.OrderId), 1),
                          _createElementVNode("li", null, " 銀行名稱：" + _toDisplayString(` ${_ctx.orderDetail.PaymentBankName} (${_ctx.orderDetail.PaymentBankCode})`), 1),
                          _createElementVNode("li", null, "繳款帳號：" + _toDisplayString(_ctx.orderDetail.PaymentBankAccount), 1),
                          _createElementVNode("li", null, " 付款期限：" + _toDisplayString(_ctx.formatDate(_ctx.orderDetail.PaymentDeadline)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_295
                  ]),
                  (_ctx.orderDetail.Remark !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_296, [
                        _hoisted_297,
                        _createElementVNode("div", _hoisted_298, _toDisplayString(_ctx.orderDetail.Remark), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_299, [
                  _createElementVNode("div", _hoisted_300, [
                    _createElementVNode("div", _hoisted_301, [
                      _hoisted_302,
                      _createElementVNode("div", _hoisted_303, " NT. " + _toDisplayString(_ctx.orderDetail.CmdyAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_304, [
                      _hoisted_305,
                      _createElementVNode("div", _hoisted_306, " NT. " + _toDisplayString(_ctx.orderDetail.FreightAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_307, [
                      _hoisted_308,
                      _createElementVNode("div", _hoisted_309, " - NT. " + _toDisplayString(_ctx.orderDetail.Discount), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_310, [
                    _createElementVNode("div", _hoisted_311, [
                      _hoisted_312,
                      _createElementVNode("div", _hoisted_313, " NT. " + _toDisplayString(_ctx.orderDetail.TotalAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_314, [
                      (_ctx.orderDetail.GoToUrl != '')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "leading-9 sm:leading-[50px] text-center bg-gary-text-color tracking-[.1em] text-white rounded-[10px] text-sm sm:text-base cursor-pointer hover:bg-primary-color active:bg-primary-color",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.payment(_ctx.orderDetail.OrderId, _ctx.orderDetail.GoToUrl)))
                          }, " 再次付款 "))
                        : _createCommentVNode("", true),
                      (
                      _ctx.orderDetail.Status === 'EcPayChangingStore' ||
                      _ctx.orderDetail.Status === 'EcPayRecreate'
                    )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "leading-9 sm:leading-[50px] text-center bg-gary-text-color tracking-[.1em] text-white rounded-[10px] text-sm sm:text-base cursor-pointer hover:bg-primary-color active:bg-primary-color",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openECPay()))
                          }, " 重選門市 "))
                        : _createCommentVNode("", true),
                      (
                      _ctx.orderDetail.Status === 'Paying' ||
                      _ctx.orderDetail.Status === 'PayFailure'
                    )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "leading-9 sm:leading-[50px] text-center bg-black-200-color tracking-[.1em] text-gary-text-color rounded-[10px] text-sm sm:text-base cursor-pointer hover:bg-primary-color hover:text-white active:bg-primary-color active:text-white",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.cancel(_ctx.orderDetail.OrderId)))
                          }, " 取消訂單 "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_315, [
          _hoisted_316,
          _createElementVNode("div", _hoisted_317, [
            _hoisted_318,
            _createElementVNode("div", _hoisted_319, [
              _createVNode(_component_TextArea, {
                placeholder: '有什麼問題想發問呢？',
                height: '140px',
                width: '100%'
              }),
              _createElementVNode("div", _hoisted_320, [
                _createElementVNode("div", _hoisted_321, [
                  _createVNode(_component_Icon, {
                    iconName: "add_black",
                    width: '24px'
                  }),
                  _hoisted_322
                ]),
                _hoisted_323
              ]),
              _hoisted_324
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}